<section class="full-height flex-column">
  <vdw-tabs-menu-card
    [identifier]="HEADER_IDENTIFIER"
    [icon]="isEditingProductConfiguration() ? 'details-blue' : 'add-blue'"
    [action]="getTabAction()"
    [title]="generalForm.get('name').value"
    [saving]="saving"
    [menuItems]="menuItems"
    [selectedMenuItem]="selectedMenuItem"
    [canShowCustomSettings]="canShowCustomSettingsButton()"
    [canShowDuplicate]="isEditingProductConfiguration()"
    [canShowDelete]="isEditingProductConfiguration()"
    settingsTooltip="GENERAL.CUSTOM_SETTINGS.CUSTOM_SETTINGS"
    (selectedMenuItemChange)="onSelectedMenuItemChange($event)"
    (settingsEvent)="navigateToCustomSettings()"
    (cancelEvent)="navigateBack()"
    (saveEvent)="save(SAVE)"
    (saveAndCloseEvent)="save(SAVE_AND_CLOSE)"
    (saveAndCreateNewEvent)="save(SAVE_AND_CREATE_NEW)"
    (duplicateEvent)="duplicate()"
    (deleteEvent)="delete()"
    (backEvent)="navigateBack()"
  >
    <button
      *appHasPermission="texeditCadCamProductConfigurationPermission"
      mat-icon-button
      class="mat-icon-action-button-lg-with-border"
      (click)="openCadCam($event.target)"
      [disabled]="!canExecuteActions()"
      [matTooltip]="'GENERAL.ACTIONS.OPEN_IN_CAD_CAM' | bmsTranslate"
      id="buttonOpenCadCamProtocolKnownFocusWorkaround"
    >
      <mat-icon svgIcon="open-external"></mat-icon>
    </button>
    <button
      *appHasPermission="texfabProductionSchedulePermission"
      mat-icon-button
      class="mat-icon-action-button-lg-with-border"
      [disabled]="!canExecuteActions()"
      [matTooltip]="'GENERAL.ACTIONS.CREATE_SAMPLE_OBJECT' | bmsTranslate: {object: 'PRODUCTION_ORDER.PRODUCTION_ORDER' | bmsTranslate: {count: 1} | lowercase}"
      (click)="addProductionScheduleForProductConfiguration()"
    >
      <mat-icon svgIcon="add-prod-order"></mat-icon>
    </button>
  </vdw-tabs-menu-card>
  <ng-container>
    <div *ngIf="productConfigurationLocked" class="unlock-in-use-wrapper">
      <app-unlock-in-use
        [name]="generalForm.get('name').value"
        [customMessage]="customMessageTranslationKeys"
        [locked]="productConfigurationLocked"
        (lockedChange)="unlockProductConfiguration()"
      ></app-unlock-in-use>
    </div>
  </ng-container>
  <div fxLayout="row" fxLayoutGap="16px" class="full-height overflow-hidden full-width" *ngIf="canShowGeneralTab()">
    <form [formGroup]="generalForm" class="form" appBreadcrumbFormLinker>
      <mat-card class="skeleton-wrapper full-height">
        <mat-card-content class="form-scrollable-content">
          <article fxLayout="column">
            <h4 class="font-weight-semibold general-title">{{ 'GENERAL.GENERAL' | bmsTranslate }}</h4>
            <mat-form-field class="full-width">
              <mat-label>{{ 'GENERAL.NAME' | bmsTranslate }}</mat-label>
              <input matInput type="text" formControlName="name" />
              <mat-hint *ngIf="canShowSuggestionForProductConfigurationName()" class="flex-row">
                <vdw-ellipsis-label
                  class="overflow-hidden"
                  [text]="'GENERAL.SUGGESTION' | bmsTranslate: {value: suggestionForProductConfigurationName}"
                  matTooltipPosition="below"
                ></vdw-ellipsis-label>
                <a class="url" (mousedown)="applySuggestionForProductConfigurationName()">{{ 'GENERAL.ACTIONS.APPLY' | bmsTranslate }}</a>
              </mat-hint>
              <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'required'">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
              <mat-error *vdwCanShowErrorForFormControl="'name'; error: 'identifierTaken'">
                {{ 'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{ 'MACHINE.MACHINE' | bmsTranslate: {count: 1} }}</mat-label>
              <vdw-object-selection
                formControlName="machine"
                [objectName]="'MACHINE.MACHINE' | bmsTranslate: {count: 1} | lowercase"
                [baseRouterLink]="MACHINE_BASE_ROUTER_LINK"
                (selectClicked)="selectMachine()"
              ></vdw-object-selection>
              <mat-error *vdwCanShowErrorForFormControl="'machine'; error: 'required'">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{ 'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} }}</mat-label>
              <vdw-object-selection
                formControlName="quality"
                [objectName]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} | lowercase"
                [chipValueKey]="QUALITY_CHIP_VALUE_KEY"
                [baseRouterLink]="QUALITY_BASE_ROUTER_LINK"
                (selectClicked)="selectQuality()"
              ></vdw-object-selection>
              <mat-error *vdwCanShowErrorForFormControl="'quality'; error: 'required'">
                {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{ 'TEXTILE_DATA.WEAVE_STRUCTURE.WEAVE_STRUCTURE' | bmsTranslate: {count: 1} }}</mat-label>
              <input matInput disabled type="text" [value]="getWeaveStructureName()" />
            </mat-form-field>
          </article>
        </mat-card-content>
      </mat-card>
    </form>
    <mat-card class="skeleton-wrapper full-height designs">
      <mat-card-content class="form-scrollable-content">
        <article class="flex-column gap-16 full-height">
          <div class="flex-row flex-start-center designs-header">
            <h4 class="font-weight-semibold">{{ 'PRODUCTION_ORDER.DESIGN_LIBRARY.VIEW_MODES.DESIGNS' | bmsTranslate }}</h4>
            <div class="full-width flex-row flex-end-center gap-16">
              <mat-slide-toggle [ngModel]="showSelected" (ngModelChange)="onShowSelectedToggleChange($event)">{{ 'GENERAL.SELECTED' | bmsTranslate }}</mat-slide-toggle>
            </div>
          </div>
          <ng-container *ngIf="gridOptionsForListOfDesigns">
            <div *ngIf="!showSelected; else selected" class="full-height flex-row">
              <ag-grid-angular #designsGrid class="ag-theme-vdw full-width" [class.loading]="loadingForTheFirstTime" [gridOptions]="gridOptionsForListOfDesigns"></ag-grid-angular>
            </div>
            <ng-template #selected>
              <div class="full-height flex-row">
                <ag-grid-angular #selectedDesignsGrid class="ag-theme-vdw full-width" [gridOptions]="gridOptionsForListOfSelectedDesigns" [rowData]="selectedDesigns"></ag-grid-angular>
              </div>
            </ng-template>
          </ng-container>
        </article>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="full-height overflow-hidden half-width full-width-mobile" *ngIf="canShowOptionalSettingsTab()" vdwBp.gt-md="one-third-width">
    <form [formGroup]="additionalOptionsForm" class="full-height">
      <mat-card class="skeleton-wrapper full-height">
        <mat-card-content class="form-scrollable-content">
          <article class="flex-column">
            <h4 class="font-weight-semibold general-title">{{ 'GENERAL.OPTIONAL_SETTINGS' | bmsTranslate }}</h4>
            <mat-form-field class="full-width">
              <mat-label>
                {{ 'PRODUCT_CONFIGURATION.HELP_WEAVE_STRUCTURE' | bmsTranslate: {count: 2} }}
              </mat-label>
              <vdw-object-selection
                formControlName="helpWeaveStructures"
                [objectName]="'PRODUCT_CONFIGURATION.HELP_WEAVE_STRUCTURE' | bmsTranslate: {count: 2} | lowercase"
                [baseRouterLink]="WEAVE_STRUCTURE_BASE_ROUTER_LINK"
                (selectClicked)="selectHelpWeaveStructures()"
              ></vdw-object-selection>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>
                {{ 'TEXTILE_DATA.COLORED_YARN_SET.COLORED_YARN_SET' | bmsTranslate: {count: 1} }}
              </mat-label>
              <vdw-object-selection
                formControlName="coloredYarnSet"
                [objectName]="'TEXTILE_DATA.COLORED_YARN_SET.COLORED_YARN_SET' | bmsTranslate: {count: 1} | lowercase"
                [baseRouterLink]="COLORED_YARN_SET_BASE_ROUTER_LINK"
                (selectClicked)="selectColoredYarnSet()"
              ></vdw-object-selection>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>
                {{ 'PRODUCT_CONFIGURATION.WEFT_COLORED_YARN_SET' | bmsTranslate }}
              </mat-label>
              <vdw-object-selection
                formControlName="weftColoredYarnSet"
                [objectName]="'PRODUCT_CONFIGURATION.WEFT_COLORED_YARN_SET' | bmsTranslate | lowercase"
                [baseRouterLink]="WEFT_COLORED_YARN_SET_BASE_ROUTER_LINK"
                (selectClicked)="selectWeftColoredYarnSet()"
              ></vdw-object-selection>
            </mat-form-field>
            <mat-form-field>
              <mat-label>
                {{ 'GENERAL.DESCRIPTION' | bmsTranslate }}
              </mat-label>
              <input matInput type="text" formControlName="description" />
            </mat-form-field>
          </article>
        </mat-card-content>
      </mat-card>
    </form>
  </div>
  <div class="full-height" *ngIf="canShowVersionHistoryTab()">
    <mat-sidenav-container fxFlex class="full-height sidenav-container sidenav-border" [hasBackdrop]="false">
      <mat-sidenav #sidenav [opened]="canShowVersionHistoryDetails()" class="sidebar sidebar-large" mode="over" position="end" [fixedInViewport]="false" [autoFocus]="false">
        <div class="full-height" *ngIf="canShowVersionHistoryDetails()">
          <section class="full-height sidebar-content skeleton-wrapper" fxLayout="column">
            <vdw-header
              [title]="'PRODUCTION_ORDER_LITE.VERSION_HISTORY.VERSION_TITLE' | bmsTranslate"
              svgIcon="info-blue"
              [canShowClose]="true"
              (closeEvent)="closeSelectedVersionHistoryDetails()"
            ></vdw-header>
            <article fxFlex="2 0" fxLayoutGap="16px" fxLayout="column" class="version-history-details-content">
              <mat-form-field>
                <mat-label>
                  {{ 'PRODUCTION_ORDER_LITE.VERSION_HISTORY.ADDITIONAL_INFORMATION' | bmsTranslate }}<span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
                </mat-label>
                <textarea matInput type="text" class="not-resizable" [formControl]="additionalInformation"></textarea>
              </mat-form-field>
            </article>
            <mat-toolbar fxFlex="0 0 72px" fxLayoutAlign="center center" fxLayoutGap="16px">
              <button mat-flat-button (click)="updateReadyForProduction()">
                {{ getButtonTitle() | bmsTranslate }}
              </button>
              <ng-container>
                <div class="button-skeleton-wrapper raised-btn">
                  <vdw-progress-button [inProgress]="saving" (progressClick)="updateAdditionalInformation()"></vdw-progress-button>
                </div>
              </ng-container>
            </mat-toolbar>
          </section>
        </div>
      </mat-sidenav>
      <mat-sidenav-content>
        <mat-card appearance="raised" fxFlex class="skeleton-wrapper full-height no-margin full-max-width version-history">
          <mat-card-content class="full-height">
            <article class="full-height">
              <ag-grid-angular #versionsHistoryGrid class="ag-theme-vdw" [gridOptions]="gridOptionsForListOfVersionHistories" [rowData]="listOfVersionHistories"></ag-grid-angular>
            </article>
          </mat-card-content>
        </mat-card>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</section>
